import type { FaireProductEntity } from "../../entity_types/product";

export const p_qqw4d9hdb6: FaireProductEntity = {
  token: "p_qqw4d9hdb6",
  type: "product",
  name: "Lei Aloha - Greeting Card",
  brandName: "Design Jord",
  imageUrl:
    "https://cdn.faire.com/fastly/4ef8105869af9bb82dc64e152898e6081862cffbe4a98c2993fbf030fb8e41a0.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/978570c0dfdaf8951f91dae6e05292197d7f5beb166343971e9e53fe38749918.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
